import React from 'react';
import InsightsContext from '../context/InsightsContext';
import {
  Container,
  Wrapper,
  SearchButton,
  SearchInput,
} from './styles/InnerBannerSearchBar.styled';

export default function InnerBannerSearchBar({ placeholder }) {
  const { setSearchValue } = React.useContext(InsightsContext);
  const [searchTemp, setSearchTemp] = React.useState('');

  const handleKeyPress = ({ keyCode }) => {
    if (keyCode === 13) setSearchValue(searchTemp);
  };

  const handleClick = () => setSearchValue(searchTemp);
  const handleChange = ({ target: { value } }) => setSearchTemp(value);

  return (
    <Container>
      <Wrapper>
        <SearchInput
          onKeyDown={handleKeyPress}
          placeholder={placeholder}
          value={searchTemp}
          onChange={handleChange}
          className="search_input"
        />
        <SearchButton onClick={handleClick}>
          <span name="search" className="search_icon" />
        </SearchButton>
      </Wrapper>
    </Container>
  );
}
